export default "__VITE_ASSET__134dba63__"